// extracted by mini-css-extract-plugin
export default {"error":"search-number-of-results-module--error--9139e"};